export enum SUBJECT_TYPE {
  THERAPY_EVENT = 'TherapyEvent',
  TREATMENT_GOAL = 'TreatmentGoal',
  ORGANIZATION = 'Organization',
  TENANT = 'Tenant',
  LOGIN = 'LOGIN',
  FILE_IMPORT = 'FileImport',
}
